export default __webpack_public_path__ + "static/media/DavidArnold.41e9e55a.png";